import React from 'react';

import { POSList } from '@C/Reports/_utils/POSList';

import { LedgerReport } from '../LedgerReport';

const POSLedger = () => {
  return (
    <LedgerReport
      title="POS Ledger"
      entityLabel="POS Name"
      SelectorComponent={POSList}
      source="SWIPE"
      showTotals={true}
      dateRangeLimit={1}
      dateRangeLimitType="month"
    />
  );
};

export { POSLedger };
